import React, { useEffect, useRef, useState } from 'react'

import { Link, useNavigate } from 'react-router-dom';

//api
import axios from "../utils/axios"

//toast
import 'react-toastify/dist/ReactToastify.css'; // import first and after the toastify is work 
import { toast } from 'sonner'

//auth
import useAuth from '../context/hook/useAuth';


export const Otp = () => {

    const [otp, setOtp] = useState("")
    const [resetOtp, setResetOtp] = useState('')
    const [second, setSecond] = useState(60)

    const navigate = useNavigate()
    const ref = useRef("otp")

    const { auth,dispatch } = useAuth()

    const handleSubmit = (e) =>{
        e.preventDefault()

        try {
            // eslint-disable-next-line
            if(auth.otp == otp && ref.current == "otp"){
                dispatch({
                    type: "LOGIN",
                    payload: auth.token
                })
                localStorage.setItem("cthash",auth.token)
                setTimeout(()=>{
                    navigate('/wallet',{replace: true})
                },2000)
                toast.success("Verification Code Verified Succesfully",{ position:"top-right" })
                 // eslint-disable-next-line
            } else if(ref.current === "hi" && resetOtp == otp){
                // console.log("yes da")
                dispatch({
                    type: "LOGIN",
                    payload: auth.token
                })
                localStorage.setItem("cthash",auth.token)
                setTimeout(()=>{
                    navigate('/wallet',{replace: true})
                },2000)
                toast.success("Verification Code Verified Succesfully",{ position:"top-right" })
            } else{
                toast.error("Please enter valid verification code",{position:"top-right"})
            }
        } catch (error) {
            toast.error(error.message,{ position:"top-right" })
        }
    }

    const handleClick = async(e) =>{
        e.preventDefault()

        try {
            await axios.get("/resendotp",
                {
                    headers:{
                        "Content-Type": "application/json",
                        "Authorization":auth.token
                    },
                  withCredentials:true,
                },
            ).then((res)=>{
                ref.current = "hi"
                const otp = res?.data.otp
                // console.log(otp)
                setOtp("")
                setResetOtp(otp)
                setSecond(60)
                toast.success("Verification code has been Resend Succesfully",{ position:"top-right" })
            })
        } catch (error) {
            console.log(error)
        }
    }

    
  useEffect(()=>{
    const interval = setInterval(()=>{
      
      if(second > 0 ){
        setSecond( second - 1)
      }

      if(second === 0){
        clearInterval(interval)
      }
    },1000)

    return ()=>{
      clearInterval(interval)
    }
  },[second])


  return (
    <div>
         {/* <!-- section start --> */}
         <div className="container">
                     <div className="row justify-content-center">
                         <div className="col-lg-6">
                         <div className="loging-logo">
                 <Link to={'/'} className="">
                     {/* Coinstirs */}
                     <img  src={require("../../assets/logo.png")} className="img-fluid robot-img" alt="robot" />
                     </Link>
                 </div>
                         </div>
                     </div>
                 </div>
        <section className="login-section section-b-space">
           
            <div className="row m-0">
                <div className="col-lg-7 d-lg-inline-block d-none p-0">
                <div className="log-display">
                    <img  src={require("../../assets/logo-banner.png")} className="img-fluid robot-img" alt="robot" />
                    </div>
                    {/* <div className="login-animation">
                        <img src={require("../../assets/svg/home/log3.svg").default} data-aos="fade-up" data-aos-duration="1000" data-aos-delay="100"
                            className="img-fluid img-base aos-animate w-600" alt=""/>
                        <img src={require("../../assets/svg/home/log1.svg").default} data-aos="zoom-in-up" data-aos-duration="1000"
                            data-aos-delay="1000" className="img-fluid img-light aos-animate w-600" alt=""/>
                        <div className="img-face" data-aos-delay="2500" data-aos="flip-left" data-aos-easing="ease-out-cubic"
                            data-aos-duration="1000"> <img src={require("../../assets/svg/home/log.svg").default}  className="img-fluid aos-animate w-450" alt=""/></div>
                    </div> */}
                </div>
                <div className="col-xxl-4 col-lg-5 ms-auto p-0">
                    <div className="login-box mt-sm-0">
                        <div>
                            <h2><span>Verification code</span></h2>
                            {/* <p>Enter the OTP send to {auth.email}</p>{phone.slice(0,3) + '-' + phone.slice(3, 6)} */}
                            <p>Enter the OTP send to {auth.email ? auth?.email.slice(0,4)+"*****"+auth?.email.slice(-10): ''}</p>
                            <form className="auth-form" onSubmit={handleSubmit} >
                                <div className="mb-3">
                                    <label htmlFor="otp" className="form-label">OTP</label>
                                    <input value={otp} onChange={e=>setOtp(e.target.value)} type="number" placeholder="Enter 6 digit code" className="form-control"
                                        id="otp"/>
                                    <div>
                                        {
                                            second > 0 ? (
                                                <p>Time Remaining: {second < 10 ? `0${second}`: second} Secs</p>
                                            ) : (
                                                <p>Didn't receive the OTP?
                                                    {
                                                        second === 0 ? (
                                                            <button  className="log-btn" onClick={handleClick}>Resend OTP</button>
                            
                                                        ) : (
                                                            <p>Resend OTP</p>
                                                        )
                                                    }
                                                </p>
                                            )
                                        }
                                    </div>
                                </div>
                                <button data-cursor="pointer" className="btn-solid btn-absolute text-center mt-3">Submit</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        {/* <!-- section end --> */}
    </div>
  )
}
